<template>
  <detail-page-layout :config="pageConfig">
    <el-table v-loading="IsLoading" element-loading-text="加载中" :data="[Order]">
      <el-row>
        <el-table-column label="租赁订单" prop="Code"></el-table-column>
        <el-table-column label="发货类型">
          <template scope="props">{{props.row.ShipmentType | RentalOrderDeliveryType}}</template>
        </el-table-column>
        <el-table-column label="订单类型">
          <template scope="props">{{props.row.OrderType | RentalOrderOrderType}}</template>
        </el-table-column>
        <el-table-column label="订单押金">
          <template scope="props">{{props.row.PledgeAmount | amount}}</template>
        </el-table-column>
        <el-table-column label="保修费用">
          <template scope="props">{{props.row.WarrantyAmount | amount}}</template>
        </el-table-column>
        <el-table-column label="订单租金">
          <template scope="props">{{props.row.TotalRentalAmount | amount}}</template>
        </el-table-column>
        <el-table-column label="客户合同编号" prop="CustomerContractCode"></el-table-column>
        <el-table-column label="区域" prop="RegionName"></el-table-column>
      </el-row>
      <el-row>
        <el-table-column type="expand">
          <template scope="props">
            <el-form class="demo-table-expand" label-position="left" inline>
              <el-form-item label="客户订单号：">
                <span>{{props.row.CustomerOrderCode}}</span>
              </el-form-item>
              <el-form-item label="联系人：">
                <span>{{props.row.ImmediateDeliveryContactName}}</span>
              </el-form-item>
              <el-form-item label="联系人电话：">
                <span>{{props.row.ImmediateDeliveryContactPhone}}</span>
              </el-form-item>
              <el-form-item label="联系人地址：">
                <span>
                  {{props.row.ImmediateDeliveryProvinceName}}
                  {{props.row.ImmediateDeliveryCityName}}
                  {{props.row.ImmediateDeliveryCountyName}}
                  {{props.row.ImmediateDeliveryAddress}}
                </span>
              </el-form-item>
              <el-form-item label="客户订单备注：" style='width:100%'>
                <span>{{props.row.CustomerNotes}}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
      </el-row>
    </el-table>
    <h3 style="line-height: 3em;">物料清单</h3>
    <!-- <el-table :data="Order.ProductLines" class="table-shin-expand">
      <el-table-column type="expand">
        <template scope="props">
          <div class="inner-list" v-for="row in Order.ProductLotLines" :key="row.Id">
            <div class="list-item">
              <label>批次号</label>
              <p class="no-margin">{{row.LotCode}}</p>
            </div>
            <div class="list-item" style="text-align: center;">
              <el-tag type="primary" style="margin-top: 8px">{{row.ConditionName}}</el-tag>
            </div>
            <div class="list-item">
              <label>租赁周期：</label>
              <p class="no-margin">{{row.RentalPeriod}}个月</p>
            </div>
            <div class="list-item">
              <label>折扣：</label>
              <p class="no-margin">{{row.DiscountRate * 100}}%</p>
            </div>
            <div class="list-item">
              <label>租赁单价：</label>
              <p class="no-margin">￥{{row.RentalUnitPrice}}</p>
            </div>
            <div class="list-item">
              <label>保修：</label>
              <p class="no-margin">￥{{row.WarrantyAmount}}/{{row.WarrantyMonths * 30}}天</p>
            </div>
            <div class="list-item">
              <label>租金：
                <el-tooltip popper-class="blue-tooltip" effect="dark" content="租赁单价*数量+保修费用" placement="top">
                  <i class="el-icon-information"></i>
                </el-tooltip>
              </label>
              <p class="no-margin">￥{{row.RentalAmount}}</p>
            </div>
          </div>
          <p class="sent-lot-title">已发货批次</p>
          <div class="inner-list" v-for="row in Order.ProductLotLines" :key="row.Id">
            <div class="list-item">
              <label>批次号</label>
              <p class="no-margin">{{row.LotCode}}</p>
            </div>
            <div class="list-item" style="text-align: center;">
              <span class="el-tag el-tag--primary" style="margin-top: 8px">{{row.ConditionName}}</span>
            </div>
            <div class="list-item">
              <label>租赁周期：</label>
              <p class="no-margin">{{row.RentalPeriod}}个月</p>
            </div>
            <div class="list-item">
              <label>折扣：</label>
              <p class="no-margin">{{row.DiscountRate * 100}}%</p>
            </div>
            <div class="list-item">
              <label>租赁单价：</label>
              <p class="no-margin">￥{{row.RentalUnitPrice}}</p>
            </div>
            <div class="list-item">
              <label>保修：</label>
              <p class="no-margin">￥{{row.WarrantyAmount}}/{{row.WarrantyMonths * 30}}天</p>
            </div>
            <div class="list-item">
              <label>租金：
                <el-tooltip popper-class="blue-tooltip" effect="dark" content="租赁单价*数量+保修费用" placement="top">
                  <i class="el-icon-information"></i>
                </el-tooltip>
              </label>
              <p class="no-margin">￥{{row.RentalAmount}}</p>
            </div>
            <div class="list-item">
              <el-button type="text">查看物流</el-button>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="物料名称" width="200px">
        <template scope="props">
          <p class="no-margin">{{props.row.ProductName}}</p>
          <p class="no-margin">物料编码：{{props.row.ProductCode}}</p>
        </template>
      </el-table-column>
      <el-table-column label="客户物料名称">
        <template scope="props">
          <p class="no-margin">{{props.row.CustomerProductName}}</p>
          <p class="no-margin" v-show="props.row.CustomerProductCode">物料编码：{{props.row.CustomerProductCode}}</p>
        </template>
      </el-table-column>
      <el-table-column label="品牌" prop="BrandName"></el-table-column>
      <el-table-column label="机型" prop="ModelName"></el-table-column>
      <el-table-column label="模块" prop="ModuleName"></el-table-column>
      <el-table-column label="租赁数量" prop="RentalQuantity"></el-table-column>
      <el-table-column label="操作">
        <template scope="props">
          <el-button type="text">维修</el-button>
          <el-button type="text">续租</el-button>
          <el-button type="text">退还</el-button>
        </template>
      </el-table-column>
    </el-table> -->
    <component :is="currentTable" :list="Order.ProductLines" :order-id="Order.OrderId"></component>
  </detail-page-layout>
</template>
<script>
import DetailPageLayout from '@/components/common/DetailPageLayout'
import LeaseDetailTableNormal from './Lease/LeaseDetailTableNormal'
import LeaseDetailTableCancel from './Lease/LeaseDetailTableCancel'
import LeaseDetailTableService from './Lease/LeaseDetailTableService'
import o from '@/odata'
// import _ from 'lodash'
export default {
  data() {
    return {
      pageConfig: {
        StepsBarEnabled: true,
        Steps: [
          { key: 'receiving', title: '等待发货' },
          { key: 'shipped', title: '部分发货' },
          { key: 'finished', title: '已完成' },
        ],
        Step: 1,
        Breadcrumbs: [
          {
            to: { name: 'LeaseList' },
            name: '租赁订单列表',
          },
          {
            name: '租赁订单',
          },
        ],
      },
      defaultSteps: [
        { key: 'receiving', title: '等待发货' },
        { key: 'shipped', title: '部分发货' },
        { key: 'finished', title: '已完成' },
      ],
      Order: {},
      currentTable: '',
      IsLoading: false,
    }
  },
  methods: {
    getOrder() {
      this.IsLoading = true
      const id = this.$route.params.id
      const Query = o(`RentalOrder(${id})/Services.GetDetail`)
      Query.get()
        .then(({ data }) => {
          this.IsLoading = false
          // 重新包装物料
          const map = {}
          data.ProductLines.forEach(item => {
            map[item.ProductId] = item
          })
          data.ProductLotLines.forEach(item => {
            const Product = map[item.ProductId]
            if (Product.LotLines) {
              Product.LotLines.push(item)
            } else {
              Product.LotLines = [item]
            }
          })
          data.ProductLines = []
          for (var key in map) {
            if (map.hasOwnProperty(key)) {
              var Product = map[key]
              data.ProductLines.push(Product)
            }
          }
          this.Order = data
          this.updateSteps(data.State, data)
        }).catch((err) => {
          this.IsLoading = false
          this.$alert(err.message, 'Error!')
        })
    },
    updateSteps(State, order) {
      this.defaultSteps[0].date = this.$moment(order.CreationTime).format('YYYY/MM/DD HH:mm:ss')
      switch (State) {
        case 'needConfirmation':
        case 'notSent':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 1)
          this.currentTable = 'LeaseDetailTableNormal'
          break
        case 'partlySent':
        case 'allSent':
          if (order.PartlySendingTime) {
            this.defaultSteps[1].date = this.$moment(order.PartlySendingTime).format('YYYY/MM/DD HH:mm:ss')
          }
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 2)
          this.currentTable = 'LeaseDetailTableNormal'
          break
        case 'normal':
        case 'completed':
          if (order.PartlySendingTime) {
            this.defaultSteps[1].date = this.$moment(order.PartlySendingTime).format('YYYY/MM/DD HH:mm:ss')
          }
          if (order.FinishTime) {
            this.defaultSteps[2].date = this.$moment(order.FinishTime).format('YYYY/MM/DD HH:mm:ss')
          }
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 3)
          this.currentTable = 'LeaseDetailTableService'
          break
        case 'cancelled':
          if (order.PartlySendingTime) {
            this.defaultSteps[1].date = this.$moment(order.PartlySendingTime).format('YYYY/MM/DD HH:mm:ss')
          }
          if (order.FinishTime) {
            this.defaultSteps[2].date = this.$moment(order.FinishTime).format('YYYY/MM/DD HH:mm:ss')
          }
          this.$set(this.pageConfig, 'Steps', [this.defaultSteps[0], this.defaultSteps[1], { key: 'cancelled', title: '已取消', state: 'failure' }])
          this.$set(this.pageConfig, 'Step', 3)
          this.currentTable = 'LeaseDetailTableCancel'
          break
      }
    },
  },
  created() {
    this.getOrder()
  },
  components: {
    DetailPageLayout,
    LeaseDetailTableNormal,
    LeaseDetailTableCancel,
    LeaseDetailTableService,
  },
}
</script>

<style lang="less" scoped>
.el-icon-information:hover {
  color: #20a0ff;
}
.sent-lot-title {
  color: #e88603;
  font-size: 13px;
  margin: 26px 0 0 58px;
  &:before {
    content: ' ';
    display: inline-block;
  }
}
.inner-list {
  margin: 0 30px;
  padding: 16px 28px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  border-bottom: 1px solid #e6eaee;
  &:last-child {
    border-bottom: none;
  }
  .list-item {
    margin-right: 20px;
    min-width: 100px;
    font-weight: bold;
    &:last-child {
      margin-right: 0;
    }
    label {
      font-size: 12px;
      color: #86939e;
      line-height: 1.5;
    }
    p {
      color: #364152;
    }
  }
}
</style>

<style lang="less">
.el-tooltip__popper.is-dark.blue-tooltip {
  background: #20a0ff;
  .popper__arrow, .popper__arrow::after {
    border-top-color: #20a0ff;
  }
}
</style>



// WEBPACK FOOTER //
// LeaseDetailPage.vue?38d7a6a4